import Button from '@ui/Button';
import SafeImage from '@ui/SafeImage';
import React from 'react';

const MTBCTA = () => {
  return (
    <div className="relative flex h-[38.5rem] items-center justify-end self-stretch rounded-brand bg-black px-[6.4rem] py-[8rem]">
      <SafeImage
        src="https://cdn.mxlocker.com/banners/mtb-cta-new.webp"
        fill
        className="rounded-brand object-cover"
        alt="mountain bike call to action"
      />
      <div className="absolute left-0 h-full w-full bg-gradient-to-r from-[rgba(0,0,0,.1)] to-[rgba(0,0,0,.9)]"></div>
      <div className="z-10 flex w-[40rem] flex-col items-start gap-[4rem]">
        <div className="flex items-center rounded-[3.2rem] bg-brand-secondary px-[1.6rem] py-[0.4rem] text-white">
          New Category
        </div>
        <h3 className="text-[3.2rem] text-white">Explore MTB</h3>
        <span className="text-white">
          Shop the largest selection of new and used mountain bikes, parts, gear
          and accessories.
        </span>
        <Button
          type="outline"
          text="Explore Mountain Bikes"
          href="/shop/mountain-bikes"
        />
      </div>
    </div>
  );
};

export default MTBCTA;
